import type { BattleReportInput } from "./report.js";
import { kcal } from "./numbers.js";
import { RACE_DATE_LABEL } from "./plan.js";
import { battleReport } from "./report.js";
import { measurementView, trendCells } from "./measurement-view.js";

/**
 * 「複製文字戰報」按鈕產生的純文字。
 *
 * 這是戰報的兩個 adapter 之一——數字全部來自 `battleReport()`，趨勢摘要那幾格
 * 的**格式**全部來自 `trendCells()`，這裡只排版。另一個 adapter 是分享頁
 * （`ShareTab`）。要顯示哪幾項、用什麼標籤、排什麼順序由各自決定，但
 * **數字與寫法不可能不一樣**。
 *
 * 先前這裡有自己的 `kg()` 與 `signed()`，與三個分頁內聯的那份是同一段食譜的
 * 第四份——而這是四份裡唯一沒有基準截圖在守的呈現，也就是最容易悄悄漂開的
 * 那一份。
 */

export type SummaryInput = BattleReportInput;

/** 達標率的百分比。它不是趨勢摘要的成員，所以留在這裡。 */
function percent(value: number | null): string {
  return value === null ? "—" : `${Math.round(value)}%`;
}

export function summaryText(input: SummaryInput): string {
  const { trend, countdown, energy, compliance, assessment, rank, steps } = battleReport(input);
  /*
   * 文字戰報只有本人叫得到，所以一律是 revealed——這裡不是「繞過遮蔽」，
   * 是把同一組數字交給同一支格式化函式。
   */
  const cells = trendCells(measurementView(input.measurements, false, null), input.today);

  return `Fight Health｜Angus 進度摘要
更新：${trend.latestDate || "—"}
距離${RACE_DATE_LABEL}臺北馬：${countdown.remaining}天
目前體重：${cells.weight.text}
目標差距：${cells.gapToTarget.text}
7日平均：${cells.avg7.text}
本週變化：${cells.weeklyChange.text}
7日平均體脂：${cells.avgFat7.text}
28日淨體重變化：${cells.leanChange.text}
${RACE_DATE_LABEL}預估：${cells.prediction.text}
訓練達標率：${percent(compliance.workout)}
三餐蛋白質達標率：${percent(compliance.protein)}
今日步數：${steps === null ? "—" : Math.round(steps).toLocaleString("zh-TW")}
今日Rank：${rank.grade}
估算BMR：${kcal(energy.bmr)} kcal
今日估算TDEE：${kcal(energy.tdee)} kcal
今日建議攝取：${kcal(energy.low)}–${kcal(energy.high)} kcal
判斷：${assessment.label}
建議：${assessment.advice}`;
}
